"use client";

export type SharedMediaProvider = "spotify" | "youtube" | "applemusic";
export type SessionAccessMode = "participant" | "admin";

function firstString(value: string | null | undefined) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed || null;
}

export function normalizeSharedMediaProvider(
  value: string | null | undefined,
): SharedMediaProvider | null {
  const normalized = firstString(value)?.toLowerCase();
  if (
    normalized === "spotify" ||
    normalized === "youtube" ||
    normalized === "applemusic"
  ) {
    return normalized;
  }
  return null;
}

export function withAdminSessionHeaders(init?: RequestInit): RequestInit {
  return {
    cache: "no-store",
    ...(init ?? {}),
  };
}

export function resolveSessionMediaProvider(
  userProvider: string | null | undefined,
  overrideProvider: string | null | undefined,
  accessMode: SessionAccessMode,
) {
  void overrideProvider;
  void accessMode;
  return normalizeSharedMediaProvider(userProvider);
}
